import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {searchUserRoutes} from "./search-user-routes";


@NgModule({
  imports: [RouterModule.forChild(searchUserRoutes)],
  exports: [RouterModule]
})
export class SearchUserRoutingModule { }
